import Button from "components/base/Button";
import MaterialRow from "./MaterialRow";

const MaterialsView = ({ product, setProduct, allMaterials }) => {
  function addMaterial() {
    setProduct({
      ...product,
      materials: [...(product.materials || []), { materialId: 0, weight: 0 }],
    });
  }

  function onChangeMaterialRow(index, value) {
    setProduct({
      ...product,
      materials: product.materials.map((m, i) =>
        i === index ? { ...m, ...value } : m,
      ),
    });
  }

  const productMaterials = product.materials || [];
  const totalWeight = productMaterials.reduce(
    (acc, m) => acc + parseFloat(m.weight || 0),
    0,
  );

  return (
    <div className="card py-4">
      <div className="-mx-2">
        <table>
          <thead>
            <tr>
              <th>Materials</th>
              <th className="text-right">Weight(g)</th>
              <th>Remark</th>
            </tr>
          </thead>
          <tbody>
            {productMaterials.map((material, index) => (
              <MaterialRow
                key={index}
                materialOptions={allMaterials}
                value={material}
                onChange={(value) => {
                  onChangeMaterialRow(index, value);
                }}
                onDelete={() => {
                  setProduct({
                    ...product,
                    materials: product.materials.filter((_, i) => i !== index),
                  });
                }}
              />
            ))}
          </tbody>
          {productMaterials.length > 0 && (
            <tfoot className="text-xs opacity-70">
              <tr>
                <td
                  colSpan={2}
                  className={`text-right ${totalWeight > product.weight ? "text-red-600" : ""}`}
                >
                  Total: {totalWeight} / {product.weight}
                </td>
                <td></td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>

      <div className="mt-2">
        <Button onClick={addMaterial}>+ Add Material</Button>
      </div>
    </div>
  );
};

export default MaterialsView;
